<template>
  <div class="infor fl">
    <all-header
      :label="lable"
      :ischage="ischage"
      :sublabel="sublabel"
      :subtitle="subtitle"
      @getvalue="goBack"></all-header>

    <div class="preview-tip">
      在线预览证书无公章，如需查看盖章证书请点击【获取证书】进行下载。
    </div>

    <div class="preview-container" ref="previewWrap">
      <div v-if="previewLoading" class="preview-placeholder">正在加载证书预览……</div>
      <div v-else-if="previewImages.length" class="preview-images">
        <img v-for="(src, idx) in previewImages" :key="idx" :src="src" alt="证书预览" />
      </div>
      <div v-else class="preview-placeholder">暂无证书预览</div>
    </div>

    <div class="btn-row">
      <el-button type="primary" class="btn-download" @click="goDownload">获取证书</el-button>
    </div>
  </div>
</template>

<script>
import { CertificatePreviewUrl } from '../utils/api.js';
import pdfjsWorker from 'pdfjs-dist/legacy/build/pdf.worker.entry';
import AllHeader from './Modal/AllHeader.vue';

export default {
  name: 'CertificatesPreview',
  components: {
    AllHeader,
  },
  data() {
    return {
      previewUrl: '',
      previewImages: [],
      previewLoading: false,
      sublabel: '返回记录列表',
      subtitle: '',
      ischage: true,
      lable: '',
    };
  },
  mounted() {
    const pdfjsModule = require('pdfjs-dist/legacy/build/pdf.js');
    const pdfjsLib = pdfjsModule && pdfjsModule.default ? pdfjsModule.default : pdfjsModule;
    if (pdfjsLib && pdfjsLib.GlobalWorkerOptions) {
      pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;
    }
    this.lable = this.$route.query.name || '荣誉证书';
    this.subtitle = this.$route.query.award_title || '';
    const id = this.$route.query.cert_id;
    if (!id) {
      this.goBack();
      return;
    }
    this.previewUrl = CertificatePreviewUrl(id);
    this.loadPreviewImages();
  },
  methods: {
    goBack() {
      const awardId = this.$route.query.award_id;
      const awardTitle = this.$route.query.award_title;
      this.$router.push({
        path: '/member/certificates/list',
        query: {
          award_id: awardId,
          award_title: awardTitle,
          name: '荣誉证书明细',
        },
      });
    },
    goDownload() {
      this.$router.push({
        path: '/member/certificates/download',
        query: {
          cert_id: this.$route.query.cert_id,
          award_id: this.$route.query.award_id,
          award_title: this.$route.query.award_title,
        },
      });
    },
    async loadPreviewImages() {
      if (!this.previewUrl) return;
      this.previewLoading = true;
      this.previewImages = [];
      const traceInfo = { preview_url: this.previewUrl };
      console.info('[CertificatesPreview] loadPreviewImages start', traceInfo);
      try {
        const lower = this.previewUrl.toLowerCase();
        if (lower.endsWith('.png') || lower.endsWith('.jpg') || lower.endsWith('.jpeg')) {
          this.previewImages = [this.previewUrl];
          return;
        }
        const pdfjsModule = require('pdfjs-dist/legacy/build/pdf.js');
        const pdfjsLib = pdfjsModule && pdfjsModule.default ? pdfjsModule.default : pdfjsModule;
        const loadingTask = pdfjsLib.getDocument({
          url: this.previewUrl,
          withCredentials: true,
        });
        const pdf = await loadingTask.promise;
        const wrap = this.$refs.previewWrap;
        const targetWidth = wrap && wrap.clientWidth ? wrap.clientWidth : 841;
        const pages = pdf.numPages;
        for (let i = 1; i <= pages; i++) {
          const page = await pdf.getPage(i);
          const baseViewport = page.getViewport({ scale: 1 });
          const scale = targetWidth / baseViewport.width;
          const viewport = page.getViewport({ scale });
          const canvas = document.createElement('canvas');
          const context = canvas.getContext('2d');
          canvas.width = viewport.width;
          canvas.height = viewport.height;
          await page.render({ canvasContext: context, viewport }).promise;
          this.previewImages.push(canvas.toDataURL('image/png'));
        }
      } catch (e) {
        console.error('[CertificatesPreview] loadPreviewImages failed', {
          ...traceInfo,
          error_message: e && e.message,
          error_name: e && e.name,
          error_stack: e && e.stack,
        });
        this.$message.error('证书预览加载失败');
      } finally {
        this.previewLoading = false;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.infor-t-r {
  padding: 6px 14px;
  border: 1px solid #5d8dff;
  color: #5d8dff;
  border-radius: 4px;
  cursor: pointer;
  font-size: 13px;
  line-height: 18px;
}

.preview-tip {
  margin-top: 16px;
  color: #666;
  font-size: 13px;
}

.preview-container {
  margin: 24px auto 0;
  width: 100%;
  max-width: 960px;
  min-height: 540px;
  border: 1px solid #e6e8f0;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.preview-images {
  width: 100%;
}

.preview-images img {
  width: 100%;
  height: auto;
  display: block;
}

.preview-placeholder {
  color: #909399;
  font-size: 14px;
  padding: 24px 16px;
  text-align: center;
}

.btn-row {
  display: flex;
  justify-content: center;
  margin-top: 28px;
}

.btn-download {
  width: 180px;
}
</style>
